import {
  appendVueRoute,
  FeatureFlagType,
  PayedFeatureType,
  Role,
  type RoutePath,
} from '@therame/shared';
import { type RouteRecordRaw } from 'vue-router';
import { type RestrictedRecordRaw } from '..';

const routes: Array<RouteRecordRaw> = [
  {
    ...appendVueRoute<'callWaitingRoom'>('callWaitingRoom', '/call/waiting-room'),
    // Workspace catch-all (PRD #963 / RS-007): serializes the open cascade into
    // the URL so "Termin erstellen" opens the appointment composer as an inline
    // column (full-screen below tablet-landscape, side-by-side above) instead of
    // an overlay — mirroring the patient list. Empty cascade is the base path.
    path: '/call/waiting-room/:cascade(.*)?' as RoutePath<'callWaitingRoom'>,
    component: () => import('@src/components/WaitingRoom/WaitingRoom.vue'),
    meta: {
      joinsCall: true,
      layout: 'default',
      title: 'Videotherapie',
      hideTitle: false,
      requiresAuth: true,
      requiresOnboarding: true,
      noPadding: true,
      accessPossibleWithRoles: [Role.ADMIN, Role.THERAPIST, Role.PATIENT],
      accessPossibleWithPayedFeatures: [PayedFeatureType.THERAME],
      workspace: true,
      officeLocationScoped: true,
    },
  },
  {
    ...appendVueRoute<'videoCall'>('videoCall', '/consultation/:callId'),
    // Workspace catch-all (ADR-0048): „Termin erstellen" during a call opens
    // the create column. The base path is the empty-cascade case.
    path: '/consultation/:callId/:cascade(.*)?' as RoutePath<'videoCall'>,
    components: {
      default: () => import('@src/views/VideoCall.vue'),
      leftSidebar: () => import('@src/views/VideoCallInfoSideList.vue'),
      footer: () => import('@src/components/VideoCall/VideoCallFooter.vue'),
    },
    meta: {
      joinsCall: true,
      layout: 'default',
      title: 'Videosprechstunde',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithTan: true,
      accessPossibleWithRoles: [Role.ADMIN, Role.THERAPIST, Role.PATIENT],
      accessPossibleWithPayedFeatures: [PayedFeatureType.THERAME],
      noPadding: true,
      workspace: true,
      workspaceFeatureFlag: FeatureFlagType.APPOINTMENT_SCHEDULING,
    },
  },
  {
    ...appendVueRoute<'videoCallEntry'>('videoCallEntry', '/consultation/entry/:callId'),
    component: () => import('@src/views/VideoCallEntry.vue'),
    meta: {
      joinsCall: true,
      layout: 'default',
      title: 'Videosprechstunde Vorbereitung',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithTan: true,
      accessPossibleWithRoles: [Role.ADMIN, Role.THERAPIST, Role.PATIENT],
      accessPossibleWithPayedFeatures: [PayedFeatureType.THERAME],
    },
  },
  {
    ...appendVueRoute<'videoCallPre'>('videoCallPre', '/consultation/pre/:callId'),
    component: () => import('@src/views/VideoCallPre.vue'),
    meta: {
      joinsCall: true,
      layout: 'default',
      title: 'Videosprechstunde Vorbereitung',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithTan: true,
      accessPossibleWithRoles: [Role.ADMIN, Role.THERAPIST, Role.PATIENT],
      accessPossibleWithPayedFeatures: [PayedFeatureType.THERAME],
    },
  },
] satisfies RestrictedRecordRaw[];

export default routes;
